import { render, staticRenderFns } from "./QuestionCollection.vue?vue&type=template&id=135ca56b&"
import script from "./QuestionCollection.vue?vue&type=script&lang=js&"
export * from "./QuestionCollection.vue?vue&type=script&lang=js&"
import style0 from "./QuestionCollection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports